import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Barbers from "@/components/Barbers";
import HouseCall from "@/components/HouseCall";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#050505] text-white min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <HouseCall />
      <Barbers />
      <Gallery />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
